import { render, staticRenderFns } from "./CaseRecord.vue?vue&type=template&id=62da16fa&scoped=true&"
import script from "./CaseRecord.vue?vue&type=script&lang=js&"
export * from "./CaseRecord.vue?vue&type=script&lang=js&"
import style0 from "./CaseRecord.vue?vue&type=style&index=0&id=62da16fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62da16fa",
  null
  
)

export default component.exports